export function formatInvalidImageTypeMessage(allowedTypes) {
  const types = allowedTypes.map(type => type.replace('image/', '').toUpperCase())

  return `Please select an image file (${types.join(', ')}).`
}
